import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function GoogleCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionToken = searchParams.get('session_token');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(errorParam);
      setTimeout(() => navigate('/auth'), 3000);
      return;
    }

    if (sessionToken) {
      // Store session token
      localStorage.setItem('session_token', sessionToken);
      
      // Fetch user info
      fetchUserAndRedirect(sessionToken);
    } else {
      setError('No session token received');
      setTimeout(() => navigate('/auth'), 3000);
    }
  }, [searchParams, navigate]);

  const fetchUserAndRedirect = async (token) => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const user = response.data;
      localStorage.setItem('user', JSON.stringify(user));
      
      // Redirect based on role
      if (user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      setError('Authentication failed');
      setTimeout(() => navigate('/auth'), 3000);
    }
  };

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: 'linear-gradient(135deg, #F4F4F4 0%, #DADEEO 100%)' }}>
        <div className="text-center">
          <div className="text-red-600 text-xl mb-4">❌ {error}</div>
          <p className="text-gray-600">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ background: 'linear-gradient(135deg, #F4F4F4 0%, #DADEEO 100%)' }}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 mx-auto mb-4" style={{ borderColor: '#102862' }}></div>
        <p style={{ color: '#092036' }} className="font-medium">Completing sign in...</p>
      </div>
    </div>
  );
}
